<div class="container-fluid option-modal-wrapper" [ngClass]="totalData <7 ? 'filterMin' : ''">
    <div class="row">
        <div class="col">
            <div class="input-field-wrapper">
                <div class="d-flex align-items-center select-all-wrap">
                    <mat-checkbox class="mat-checkbox-general checkbox-wrap" [checked]="selectAllChecked"
                        (change)="selectAll($event)"></mat-checkbox>
                    <mat-label class="mat-label-general">Select All</mat-label>
                </div>
                <div class="d-flex align-items-center item-wrap" *ngFor="let option of optionList">
                    <mat-checkbox class="mat-checkbox-general checkbox-wrap" [checked]="isSelected(option)"
                        (change)="toggleSelection(option)"></mat-checkbox>
                    <mat-label class="mat-label-general" #tooltip="matTooltip" [matTooltip]="option.value"
                        [matTooltipPosition]="'above'">{{ option.value }}</mat-label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn secondary-ebtn" (click)="cancelClick()">Cancel</button>
                <button type="button" class="btn primary-ebtn" (click)="applyClick()">Apply</button>
            </div>
        </div>
    </div>
</div>